/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './PartiuGpNumerosDaSorte.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const PORTAL_CLIENTE_URL =
  'https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=partiu-gp-da-inglaterra:numeros-da-sorte';

function PartiuGpNumerosDaSorte() {
  return (
    <section id="partiu-gp-numeros-da-sorte">
      <ContainerHome24 className="inner">
        <div className="content">
          <h2 className="titulo">Meus números da sorte</h2>
          <p className="texto">
            Já possui seus números da sorte para participar do sorteio? Confira abaixo a partir de
            02/02/2027
          </p>
          <a href={PORTAL_CLIENTE_URL} target="_blank" rel="noopener" className="cta">
            Conferir
          </a>
        </div>
        <img
          src="assets/partiu-gp-da-inglaterra/numeros-da-sorte/piloto.png"
          alt="Carro de Fórmula 1 da Santander em alta velocidade na pista."
          className="imagem"
        />
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpNumerosDaSorte;
